//@flow
import React from 'react';
import {connect} from 'react-redux';
import SectionHeader from '../SummarySubSection/SectionHeader/SectionHeader';
import {Table, Column, Cell} from 'fixed-data-table-2';
import {
  getFormattedCell,
} from '../../CBDTables/LineItemTables/LineItemTablesContainer/LineItemTableSubSection/LineItemTableCellHelpers';
import s from './ExchangeRates.less';

type Props = {
  exchangeRateData: Object,
};
const ExchangeRateSection = (props: Props) => {
  const exchangeRates = props.exchangeRateData['Exchange Rates'];
  return (
    <div className={`shadowBox`}>
      <SectionHeader title={'Exchange Rates'} />
      <div className={`${s.topInfo}`}>
        <h3>
          <span>REFERENCE DATE: </span>
          {props.exchangeRateData['Cost Sheet Exchange Rate Effective Date']}
        </h3>
      </div>
      {exchangeRates[0] &&
        <div>
          <Table
            rowHeight={30}
            rowsCount={exchangeRates.length}
            width={750}
            maxHeight={600}
            headerHeight={30}
          >
            {Object.keys (exchangeRates[0]).map (columnKey => (
              <Column
                key={columnKey}
                columnKey={columnKey}
                header={
                  <Cell>
                    <h4 style={{margin: '0'}}>{columnKey}</h4>
                  </Cell>
                }
                cell={({rowIndex, columnKey}) =>
                  getFormattedCell (exchangeRates, rowIndex, columnKey)}
                width={150}
              />
            ))}
          </Table>
        </div>}
    </div>
  );
};

const mapStateToProps = state => ({
  exchangeRateData: state.ui.cbdUIMapping.ExchangeRateData,
});
export default connect (mapStateToProps) (ExchangeRateSection);



// WEBPACK FOOTER //
// ./src/components/SummarySubSections/ExchangeRateSection/ExchangeRateSection.js